import styled from 'styled-components';
import CardLayout from './CardLayout';
import SubHeader from './SubHeader';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CustomButton from 'components/CustomInput/Button';
import { Divider, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import { CCO, HO_ADMIN } from 'utility/lookup';
import OverviewCard from './OverviewCard';
import { useEffect, useState } from 'react';
import { FETCH_LANDING_DATA, EXPORT_SITE_INFO } from 'store/key';
import LoadingIndicator from 'components/LoadingIndicator';
import { getItem, KEYS } from 'storage';
import { getTimeWithTimeZone } from 'utility/general';

const SLandingLayout = styled.div`
    height: 100%;
    background: #f4f5f9;
`;

const SCardLayout = styled.div`
    margin-top: 10px;
`;

const SCardTitleLayout = styled.div``;

const SCardContainer = styled.div`
    margin-top: 10px;
`;

const SCardSection = styled.div`
    margin-top: 30px;
`;

const LandingPage = () => {
    const userRole = useSelector((state) => state.user.role);
    const dispatch = useDispatch();
    const landing = useSelector((state) => state.landing);
    const isLogin = useSelector((state) => state.user.isLogin);
    const [submissionFrom, setSubmissionFrom] = useState(null);
    const [submissionTo, setSubmissionTo] = useState(null);
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);

    // when user role changed, re-fetch the landing count data
    useEffect(() => {
        if (userRole && userRole !== HO_ADMIN && isLogin) {
            const accessToken = getItem(KEYS.ACCESS_TOKEN);

            // if no access token, skip fetching landing data
            if (!accessToken) {
                return;
            }

            dispatch({
                type: FETCH_LANDING_DATA,
                payload: {
                    role: userRole,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userRole]);

    const handleExport = () => {
        setForceErrorDisplay(true);
        if (submissionFrom && submissionTo) {
            dispatch({
                type: EXPORT_SITE_INFO,
                payload: {
                    data: {
                        startDate: getTimeWithTimeZone(submissionFrom).format('YYYY-M-DD'),
                        endDate: getTimeWithTimeZone(submissionTo).format('YYYY-M-DD'),
                    },
                },
            });
        }
    };

    return (
        <SLandingLayout>
            {userRole === HO_ADMIN ? null : landing?.isLoading || landing?.isError ? (
                <div
                    style={{
                        display: 'flex',
                        height: '100%',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    {landing.isLoading && <LoadingIndicator />}
                    {landing.isError && <div>Fetch Data with error</div>}
                </div>
            ) : (
                <div style={{ padding: 15 }}>
                    <SubHeader />
                    <SCardLayout>
                        {landing?.application?.length && (
                            <SCardSection>
                                <SCardTitleLayout>
                                    <TextSubHeader>Initial Applications</TextSubHeader>
                                </SCardTitleLayout>
                                <SCardContainer>
                                    <CardLayout data={landing?.application} type="application" />
                                </SCardContainer>
                            </SCardSection>
                        )}
                        {landing?.postApprovalDocument?.length && (
                            <SCardSection>
                                <SCardTitleLayout>
                                    <TextSubHeader>Post Approval Documents</TextSubHeader>
                                </SCardTitleLayout>
                                <SCardContainer>
                                    <CardLayout data={landing?.postApprovalDocument} type="postApprovalDocument" />
                                </SCardContainer>
                            </SCardSection>
                        )}

                        {userRole === CCO && (
                            <SCardSection>
                                <SCardTitleLayout>
                                    <TextSubHeader>Pending</TextSubHeader>
                                </SCardTitleLayout>
                                <SCardContainer>
                                    <OverviewCard
                                        name={'User Approval'}
                                        count={landing?.pending ? landing?.pending[0]?.totalCount : 0}
                                        // action={item.action}
                                        link={'/function/user-approval'}
                                        // item={item}
                                        color={'red'}
                                    />
                                </SCardContainer>
                            </SCardSection>
                        )}
                    </SCardLayout>
                </div>
            )}
            {userRole === HO_ADMIN && (
                <Grid container style={{ padding: '5px  10px' }}>
                    <Grid
                        container
                        alignContent={'flex-start'}
                        style={{ backgroundColor: '#FFF', minHeight: '500px', padding: '0 30px' }}
                    >
                        <Grid container item xs={12} style={{ marginTop: '20px' }}>
                            <Grid style={{ fontSize: '20px', fontWeight: 600 }}>Export Reminders info List</Grid>
                            <Divider style={{ width: '100%', marginTop: '8px', height: '2px', background: '#000' }} />
                        </Grid>
                        <Grid container alignItems={'flex-start'} style={{ marginTop: '20px' }}>
                            <Grid item style={{ width: '240px' }}>
                                <CustomDatePicker
                                    name={'submission Date (From)'}
                                    value={submissionFrom}
                                    label={'submission Date (From)'}
                                    handleChangeDate={(e) => {
                                        setSubmissionFrom(e.target.value);
                                    }}
                                    maxDate={submissionTo}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={['isRequired']}
                                />
                            </Grid>
                            <Grid item style={{ width: '240px', marginLeft: '20px' }}>
                                <CustomDatePicker
                                    name={'submission Date (To)'}
                                    value={submissionTo}
                                    label={'submission Date (To)'}
                                    handleChangeDate={(e) => {
                                        setSubmissionTo(e.target.value);
                                    }}
                                    minDate={submissionFrom}
                                    maxDate={new Date()}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={['isRequired']}
                                />
                            </Grid>
                            <Grid item>
                                <CustomButton onClick={() => handleExport()} style={{ marginLeft: '40px' }}>
                                    Export To XLS
                                </CustomButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </SLandingLayout>
    );
};

export default LandingPage;
